import styled, { keyframes, css } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const Skeleton = styled.div`
  background: linear-gradient(90deg, #e0e0e0 25%, #d1d5db 37%, #e0e0e0 63%);
  background-size: 400px 100%;
  animation: ${shimmer} 1.4s ease infinite;
  border-radius: 4px;
`;

export const Page = styled.div`
  min-height: 100vh;
  background: #f7f9fc;
  padding: 2rem;
`;

export const HeaderSkeleton = styled(Skeleton)`
  height: 48px;
  max-width: 400px;
  margin: 0 auto 32px;
`;

export const FooterSkeleton = styled(Skeleton)`
  height: 32px;
  max-width: 300px;
  margin: 48px auto 0;
`;

export const Center = styled.div`
  display: flex;
  justify-content: center;
`;

export const Card = styled.div`
  background: #ffffff;
  padding: 2rem;
  border-radius: 8px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

/* Title */
export const Title = styled(Skeleton)`
  height: 24px;
  width: 70%;
  margin: 0 auto 8px;
`;

export const Subtitle = styled(Skeleton)`
  height: 16px;
  width: 60%;
  margin: 0 auto 32px;
`;

/* Sections */
export const Section = styled.div`
  margin-bottom: 32px;
`;

export const SectionTitle = styled(Skeleton)`
  height: 18px;
  width: 40%;
  margin-bottom: 16px;
`;

export const Paragraph = styled(Skeleton)`
  height: 14px;
  width: 100%;
  margin-bottom: 12px;
`;

/* Order details */
export const OrderDetails = styled.div`
  background: #e8f5e9;
  border: 1px solid #c8e6c9;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 32px;
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DetailLabel = styled(Skeleton)`
  height: 14px;
  width: 40%;
`;

export const DetailValue = styled(Skeleton)`
  height: 14px;
  width: 30%;
`;

/* Barcode */
export const BarcodeSection = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 24px;
`;

export const BarcodeNumber = styled(Skeleton)`
  height: 36px;
  width: 100%;
  margin-bottom: 16px;
`;

export const BarcodeImage = styled(Skeleton)`
  height: 80px;
  width: 100%;
`;

/* Actions */
export const Actions = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-bottom: 24px;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const Button = styled(Skeleton)<{ outlined?: boolean }>`
  height: 42px;
  width: 180px;

  ${({ outlined }) =>
    outlined &&
    css`
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%);
    `}
`;

/* Confirmation */
export const Confirmation = styled(Skeleton)`
  height: 14px;
  width: 80%;
  margin: 24px auto 0;
`;
